import React, { useEffect, useState, useRef, useCallback } from 'react'
import Index from '../view/Index'
import { Config, IISMethods, LoginInfo, JsCall } from '../config/IISMethods'
import { connect } from 'react-redux'
import { setCookiesData, setLocalStorageData, setProps, setMenuData, setUserRights } from '../redux/actions'
import { store } from '../index'


const SignIn = (props) => {
    // get updated value from redux store
    const getCurrentState = () => {
        return store.getState()
    }

    const [state, setState] = useState({
        loginData: IISMethods.getLocalData("loginCredentials") || {
            username: '',
            loginpassword: '',
            rememberme: false,

        },
        forgetData: {
            forgetpassword: false,
            email: '',
        },
        otpData: {
            verifyotp: false,
            otp: '',
            newpassword: '',
            confirmnewpassword: '',
            clearallsessions: 0
        },
        loginWithOTPData: {  // smit surani ~ 09-04-2025 add login with otp
            loginwithOTP: false,
            username: '',
            otp: '',
            otpVerification:false,
            rememberme:false,
        },
        signUpData: {
            firstname: '',
            lastname: '',
            email: '',
            companyname: '',
            subdomainname: '',
            countryid: 'in',
            countryname: 'India',
            codecontact: '91',
            contact: '',
            password: '',
            confirmpassword: '',
            termsandcondition: 0
        },
        loginValidations: [{
            formfields: [
                {
                    field: 'username',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true,
                    // regex: `${Config.getRegex()['email']} |${Config.getRegex()['phone']}`
                    // regex: Config.getRegex()['email']
                },
                {
                    field: 'loginpassword',
                    type: 'input-text',
                    defaultvisibility: true,
                    required: true,
                }
            ]
        }],
        loginwithOTPValidations: [{  // smit surani ~ 09-04-2025 add login with otp
            formfields: [
                {
                    field: 'username',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true,
                    regex: Config.getRegex()['email']
                },
            ]
        }],
        signUpValidations: [{
            formfields: [
                {
                    field: 'firstname',
                    type: 'input-text',
                    defaultvisibility: true,
                    required: true
                },
                {
                    field: 'lastname',
                    type: 'input-text',
                    defaultvisibility: true,
                    required: true
                },
                {
                    field: 'email',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true,
                    regex: Config.getRegex()['email']
                },
                {
                    field: 'companyname',
                    'type': 'input-text',
                    defaultvisibility: true,
                    'required': true
                },
                {
                    field: 'subdomainname',
                    type: 'input-text',
                    defaultvisibility: true,
                    required: true
                },
                // {
                //     field : 'countryid',
                //     type : 'dropdown',
                //     required : true
                // },
                // {
                //     field : 'countryname',
                //     type : 'input-text',
                //     required : true
                // },
                // {
                //     field : 'codecontact',
                //     type : 'dropdown',
                //     required : true
                // },
                {
                    field: 'contact',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true,
                    regex: Config.getRegex()['phone']
                },
                {
                    field: 'password',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true
                }
            ],

        }],
        forgetPasswordValidations: [{
            formfields: [
                {
                    field: 'email',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true,
                    regex: Config.getRegex()['email']
                },
            ]
        }],
        resetPasswordValidations: [{
            formfields: [
                {
                    field: 'otp',
                    type: 'number-input',
                    required: true,
                    defaultvisibility: true,
                    minlength: 6,
                    maxlength: 6
                },
                {
                    field: 'newpassword',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true,
                    regex: Config.getRegex()['password']
                },
                {
                    field: 'confirmnewpassword',
                    type: 'input-text',
                    required: true,
                    defaultvisibility: true,
                    regex: Config.getRegex()['password']
                },
            ]
        }],
        addButtonDisable: false,
        resendOTPButtonDisable: false,
    })

    // For 2FA
    const [is2FA, setIs2FA] = useState(false)
    const [res2FAData, setRes2FAData] = useState({})
    const [recoveryButtonDisable, setRecoveryButtonDisable] = useState(false)
    const [signInWithOTPButtonDisable, setSignInWithOTPButtonDisable] = useState(false)
    const [resendOTPTimer, setResendOTPTimer] = useState({
        starttime: null,
        endtime:null
    }) //  smit surani  ~ 2025-07-02 ~ 09:10 AM
    const [reqRecoveryData, setReqRecoveryData] = useState({})
    const inputRef = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)]
    const [otpState, setOtpState] = useState({
        otp1: '',
        otp2: '',
        otp3: '',
        otp4: '',
        otp5: '',
        otp6: '',
    }) // OTP State
    const [otpError, setOtpError] = useState({}) // OTP Error
    const [otpValue, setOtpValue] = useState('') //  // smit surani ~ 09-04-2025 add login with otp

    // for wrong password login attempt
    const [attemptCount, setAttemptCount] = useState(null)
    const [tenantLogo, settenantLogo] = useState("") // Utsav 20-06-25 ~ Custom slider and tenant logo implementation
    const [sliderImages, setSliderImages] = useState("") // Utsav 20-06-25 ~ Custom slider and tenant logo implementation
    const [isUsernameErr, setIsUsernameErr] = useState(false) // state for show err for username | Nirzar Gabani 💀 ~  2025-02-01 ~ 07:10 PM
    const [logoLoader, setLogoLoader] = useState(true)
    // for new account
    // if (IISMethods.getCookiesData("loginInfo")) {
    //     if (!IISMethods.getCookiesData('loginInfo')?.status) {
    //         window.location.href = '/home'
    //     }
    //     else
    //         window.location.href = '/initialinfo'
    // }

    // | React 18 Changes JATIN 🐒 ~ 
    // for new account 
    useEffect(() => {
        async function fetchData() {
            if (IISMethods.getCookiesData("loginInfo")) {
                if (!IISMethods.getCookiesData('loginInfo')?.status) {
                    window.location.href = '/home'
                }
                else
                    window.location.href = '/initialinfo'
            }
        }

        fetchData()
        //    Comment by JATIN 03/09/2024 
        // return () =>{
        //     window.localStorage.removeItem("linkdin");
        // }
    }, [])

    //jaydeep 03-02-2023

    let subdomainFlag = false

    const verifyingsubdomain = async () => {
        const url = Config.weburl + 'verifysubdomain'
        let reqData = {
            subdomainname: IISMethods.getSubdomainName(),
            gettenantlogo: 1
        }

        let headers = {
            subdomainname: IISMethods.getSubdomainName(),
            version: Config.version,
        }


        // temp comment
        //PRIYANSHI --> SOCKET 
        let { resBody } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)

        if (resBody.status === 200) {
            subdomainFlag = true
            settenantLogo(resBody.tenantlogo)
            setSliderImages(resBody.tenantloginimages)
            setLogoLoader(false)
        }
        else {
            // live
            if (Config.getServermode() == 'prod') {
                let protocol = window.location.protocol
                let hostname = `bizcompass.app`
                window.location.href = protocol + '//' + hostname
            }
            // dev / uat 
            else {
                window.location.href = `/`
            }
            setLogoLoader(false)
        }
    }
    //jaydeep 03-02-2023

    // used to identify component mount or unmount
    const isMounted = useRef(true)

    useEffect(() => {

        async function fetchData() {
            await verifyingsubdomain()
            if (state.loginData.rememberme) {
                // JsCall.handleHasVal('form-username', state.loginData.username)
                // JsCall.handleHasVal('form-loginpassword', state.loginData.loginpassword)
            }

            // if no subdomain available thne redirect to domain name page
            //    || !subdominflag
            if ((!IISMethods.getSubdomainName())) {
                window.location.href = '/'
                return
            }
            getAccessToken()
        }

        fetchData()

        return () => {
            isMounted.current = false
        }
    }, [])

    const getAccessToken = async () => {

        const url = Config.weburl + 'getaccesstoken'


        const reqData = {
        }

        const urlparams = Config.getServermode() == 'prod' ? window.location : new URLSearchParams(window.location.search)
        let headers = {
            key: IISMethods.getCurrentState()['REACT_APP_KEY'],
            issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
            version: Config.version
            // subdomainname : Config.getServermode() == 'prod' ? urlparams.hostname?.split('.')[0] : urlparams.get('q')
        }

        //PRIYANSHI --> SOCKET
        let { resBody, resHeaders } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)

        if (resBody.status === 200) {
            LoginInfo.setToken(resHeaders.token)
            LoginInfo.setUnqkey(resBody.data.unqkey)
            LoginInfo.setUid(resBody.data.uid)
        }
        else {
            //getAccessToken()
        }
    }

    // const handleSignIn = (e) => {
    //     let states = state.loginData
    //     if (e.target.name !== "rememberme") {
    //         states[e.target.name] = e.target.value
    //         // JsCall.handleHasVal('form-'+e.target.name, e.target.value)
    //     }
    //     else {
    //         states[e.target.name] = e.target.checked
    //     }
    //     setState({ ...state, loginData: states })

    //     JsCall.validateForm(state.loginData, state.loginValidations, e.target.name)
    // }

    // signin using employee code, username or email | Nirzar Gabani 💀 ~  2025-02-01 ~ 07:08 PM
    const handleSignIn = (e) => {
        const { value } = e.target;

        let states = state.loginData
        let loginwithOTPStates=state.loginWithOTPData
        if (e.target.name === "username") {
            states[e.target.name] = e.target.value
            loginwithOTPStates[e.target.name] = e.target.value

            const emailPattern = Config.getRegex()['email']
            const contactPattern = Config.getRegex()['contactno']
            const noSpacePattern = Config.getRegex()['nospace']

            const isValidUsername = emailPattern.test(value.trim()) || contactPattern.test(value.trim()) || noSpacePattern.test(value.trim())

            // If the username doesn't match any of the regex patterns
            if (!isValidUsername) {
                JsCall.handleError('form-username', true)
                setIsUsernameErr(true)
            }
            else {
                JsCall.handleError('form-username', false)
                setIsUsernameErr(false)
            }
        }
        else if (e.target.name == "loginpassword") {
            states[e.target.name] = e.target.value
        }
        else {
            states[e.target.name] = e.target.checked
            loginwithOTPStates[e.target.name] = e.target.checked
        }

        if (e.target.name !== "username") {
            JsCall.validateForm(state.loginData, state.loginValidations, e.target.name)
        }
        setState({ ...state, loginData: states })
        setState({ ...state, loginWithOTPData: loginwithOTPStates })
    }

    const isEmail = (str) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(str);
    };

    // click on sign in
    //  for google changes | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:31 PM
    const signIn = async (e, subdomainname, msToken, instance, accounts,googlecode) => {
        if (!subdomainname && e)
            e.preventDefault()
        // const urlparams = new URLSearchParams(window.location.search)
        const urlparams = Config.getServermode() == 'prod' ? window.location : new URLSearchParams(window.location.search)
        let isValid2FAOtp = true
        if (is2FA) {
            isValid2FAOtp = handle2FAValidation()
        }

        let validateInput
        if (!msToken && !googlecode) {
            validateInput = JsCall.validateForm(state.loginData, state.loginValidations)
        }

        if ((!validateInput && isValid2FAOtp) || msToken || googlecode) {
            const url = Config.weburl + 'login'
            // Added 1 year expiry for remember me selection ~Aniket Bhesaniya
            if (state.loginData.rememberme) {
                IISMethods.setLocalData("loginCredentials", state.loginData)
            }
            else {
                IISMethods.clearLocalData("loginCredentials")
            }

            let reqData = {}
            let useraction = ''

            if (is2FA) {
                let otp2FA = Object.values(otpState).join('')
                reqData = {
                    email: isEmail(state.loginData.username) ? state.loginData.username.trim().toLowerCase() : state.loginData.username.trim(),
                    password: state.loginData.loginpassword,
                    twoFACode: otp2FA,
                    requestid: res2FAData.requestid
                }
                useraction = '2FAlogin'
            }
            else if (msToken) { //for ms login
                reqData = {
                    accessToken: msToken,
                    is_ms: 1
                }

                useraction = 'login'
            }
            else if (googlecode) { //for google login //  | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:31 PM
                reqData = {
                    code: googlecode,
                    is_google: 1
                }

                useraction = 'login'
            }
            else {
                reqData = {
                    email: isEmail(state.loginData.username) ? state.loginData.username.trim().toLowerCase() : state.loginWithOTPData?.email ? state.loginWithOTPData.email.trim().toLowerCase()  : state.loginData.username.trim(),
                    password: state.loginData.loginpassword,
                    otp: otpValue,
                }

                useraction = 'login'
            }

            let headers = {
                token: LoginInfo.getToken(),
                issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
                unqkey: LoginInfo.getUnqkey(),
                uid: LoginInfo.getUid(),
                platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
                useraction: useraction,
                pagename: IISMethods.getpagename(),
                // subdomainname: subdomainname || urlparams.get('q')
                subdomainname: subdomainname ? subdomainname : Config.getServermode() == 'prod' ? urlparams.hostname?.split('.')[0] : urlparams.get('q'),
                version: Config.version,
                moduletype: 'web'
            }
            if (!headers?.subdomainname) {
                window.location.href = `/${IISMethods.getpagename()}?q=IIS`
                return
            }
           
            //PRIYANSHI --> SOCKET
            let { resBody, resHeaders } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)


            if (resBody?.status === 200) {
                setAttemptCount(null)

                if (resBody?.data?.is2FAenable && resBody?.data?.requestid) {

                    setRes2FAData(resBody?.data)
                    setIs2FA(true)
                    setState({ ...state, addButtonDisable: false })

                    LoginInfo.setToken(resHeaders.token)
                    LoginInfo.setUnqkey(resHeaders.unqkey)
                    LoginInfo.setSubdomainName(resHeaders?.subdomainname)
                    const data = resBody?.data
                    var userrole = data.userrole
                    LoginInfo.setUid(data._id)
                    LoginInfo.setFirstname(data.firstname)
                    LoginInfo.setLastname(data.lastname)
                    LoginInfo.setPersonname(data.personname)
                    LoginInfo.setCompanyID(data.companyid)
                    //Priyanshi Userrole  --> need change
                    LoginInfo.setUserroleID(userrole[0].userroleid)
                    try {
                        LoginInfo.setBranchID(data.branch[0].branchid)
                    }
                    catch {
                    }

                    setReqRecoveryData(LoginInfo)
                }
                else {
                    LoginInfo.setSubdomainName(resHeaders?.subdomainname)
                    LoginInfo.setToken(resHeaders.token)
                    LoginInfo.setUnqkey(resHeaders.unqkey)
                    LoginInfo.setIsAnnivarsary(resBody.anniversary)
                    LoginInfo.setIsCustomer(resBody.iscustomer)
                    const data = resBody?.data[0]
                    LoginInfo.setFirstname(data.firstname)
                    LoginInfo.setLastname(data.lastname)
                    LoginInfo.setPersonname(data.personname)
                    LoginInfo.setContact(data.contact)
                    LoginInfo.setPersonemail(data.personemail)
                    LoginInfo.setWorkemail(data.workemail)
                    LoginInfo.setUid(data._id)
                    LoginInfo.setTheme(data.theme)
                    LoginInfo.setDateFormate(data.dateformat)
                    LoginInfo.setTimeFormate(data.timeformat)
                    LoginInfo.setBirthDate(data.dateofbirth)
                    const greetmsg = resBody
                    try {
                        //jaydeep 15/02/2023 - checking birtdate with current date
                        //neel 21/2/2023
                        // if (LoginInfo.birthdate.toString()?.slice(5, 10) == new Date().toISOString()?.slice(5, 10) ) {
                        //Nirzar changes for birthday and anniversary popup
                        if (greetmsg?.birthday) {
                            LoginInfo.setIsBirthdate(true)
                            LoginInfo.setBirthDayMessage(greetmsg?.greetingmessage?.birthdatemessage)
                        }
                        if (greetmsg?.anniversary) {
                            // LoginInfo.setIsBirthdate(true)
                            LoginInfo.setAnniversaryMessage(greetmsg?.greetingmessage?.anniversarymessage)
                        }
                    }
                    catch (e) {
                        console.log(e)
                    }

                    var userrole = data.userrole
                    LoginInfo.setUserroles(userrole)
                    //Priyanshi Userrole  --> need change
                    LoginInfo.setUserroleID(userrole[0].userroleid)

                    try {
                        LoginInfo.setStatus(data.status)
                        LoginInfo.setIsActive(data.isactive)
                        LoginInfo.setBranches(data.branch)
                        LoginInfo.setBranchID(data.branch[0].branchid)
                    }
                    catch {

                    }
                    LoginInfo.setCompanyID(data.companyid)
                    LoginInfo.setCompanyName(data.companyname)
                    LoginInfo.setCompanyCountryID(data.companycountryid)
                    LoginInfo.setCompanyStateId(data.companystateid)
                    LoginInfo.setCompanyCityId(data.companycityid)

                    LoginInfo.setProfilePic(data.profilepic)

                    // temp comment
                    // var userrights = new Array()

                    // try {
                    //     resBody.userrights?.map((obj) => {
                    //         var UserRight = new _UserRight()

                    //         UserRight.setID(obj._id)
                    //         UserRight.setMenuname(obj.menuname)
                    //         // UserRight.setFormname(obj.formname)
                    //         UserRight.setAlias(obj.alias)
                    //         // UserRight.setContainright(obj.containright)
                    //         UserRight.setAllviewright(obj.allviewright)
                    //         UserRight.setSelfviewright(obj.selfviewright)
                    //         UserRight.setAlladdright(obj.alladdright)
                    //         UserRight.setSelfaddright(obj.selfaddright)
                    //         UserRight.setAlleditright(obj.alleditright)
                    //         UserRight.setSelfeditright(obj.selfeditright)
                    //         UserRight.setAlldelright(obj.alldelright)
                    //         UserRight.setSelfdelright(obj.selfdelright)
                    //         UserRight.setAllprintright(obj.allprintright)
                    //         UserRight.setSelfprintright(obj.selfprintright)
                    //         UserRight.setRequestright(obj.requestright)
                    //         UserRight.setChangepriceright(obj.changepriceright)
                    //         //01-02-23
                    //         UserRight.setAllfinancialdata(obj.allfinancialdata)
                    //         UserRight.setSelffinancialdata(obj.selffinancialdata)

                    //         userrights.push(UserRight)
                    //     })
                    // }
                    // catch {
                    //     getAccessToken()
                    // }

                    IISMethods.setLocalData("iconExtension", resBody.iconextension)
                    // is super admin
                    //Priyanshi Userrole
                    // if (userrole[0].userroleid === Config.adminutype) {
                    if (userrole?.some(role => role.userroleid === Config.adminutype)) {
                        IISMethods.setLocalData("isfirsttimelogin", 1) //is first time login
                    }
                    IISMethods.setCookiesData("loginInfo", LoginInfo)

                    if (msToken) {
                        let tempCookie = IISMethods.getCookiesData("loginInfo")
                        tempCookie.is_ms = 1
                        IISMethods.setCookiesData('loginInfo', tempCookie)
                    }
                    if(googlecode) {
                        let tempCookie = IISMethods.getCookiesData("loginInfo")
                        tempCookie.is_google = 1
                        IISMethods.setCookiesData('loginInfo', tempCookie)
                    }

                    // var pagename = Config.getServermode() == 'prod' ? new URLSearchParams(urlparams.search).get('targeturl') : urlparams.get('targeturl')
                    var pagename = Config.getServermode() == 'prod' ? `${window.location.pathname.replace('/', '')}${window.location.search?.length ? window.location.search : ``}` : `${window.location.pathname.replace('/', '')}${window.location.search?.length ? window.location.search : `?q=${subdomainname}`}`
                    // Temp Comment
                    if (!resBody?.data[0]?.status) {

                        // after login successful redirect to the page which is in the url | Om Z  🌝🌝🌝 ~ 2024-08-12 ~ 05:15 PM
                        let currenturl = pagename
                        // const urlParams = new URLSearchParams(window.location.search);
                        // const redirectPath = urlParams.get('page');
                        // if customer login 
                        // if(pagename == 'home' && IISMethods.isCustomer()){
                        //     console.log("pagename",pagename)
                        //     pagename = 'clientdashboard'    
                        // }


                        if (window.location.pathname == '/login' || window.location.pathname == '/' || window.location.pathname == '') {
                            // if customer login 
                            // if(IISMethods.isCustomer()){
                            //     pagename = 'clientdashboard'    
                            // }
                            // else{
                            // for redirect to the route page | Om Z  🌝🌝🌝 ~ 2024-08-12 ~ 05:16 PM
                            // if (redirectPath) {
                            //     // Remove leading slashes from redirectPath
                            //     pagename = redirectPath.replace(/^\/+/, '');
                            // }
                            // else {
                            pagename = 'home'
                            // }
                            // }
                        }

                        if (!pagename) {
                            // if customer login 
                            // if(IISMethods.isCustomer()){
                            //     pagename = 'clientdashboard'    
                            // }
                            // else{
                            pagename = 'home'
                            // }
                        }

                        // JATIN WHEN REDIRETION FROM LINKDIN EXTEDNTION
                        // if (IISMethods.getLocalData("linkdin")) {
                        //     pagename = IISMethods.getLocalData("linkdin")
                        //     return window.location.href = `/${pagename}`
                        // }
                        // else 
                        //when login than set home default pagename
                        if (currenturl && currenturl !== "/" && currenturl !== "/login") {
                            return window.location.href = `/${currenturl}`
                        }
                        else {
                            return window.location.href = `/${pagename}`
                        }
                        // | React 18 Changes JATIN 🐒 ~ 
                        // window.location.href = `/${pagename}`
                        // window.location.href = `/${window.location.search}`
                    } else {
                        if (!resBody?.data[0].isactive) {
                            window.location.href = '/signuprequest'
                        }
                        else {
                            pagename = 'initialinfo'
                            window.location.href = `/${pagename}`
                        }
                    }
                }


                // }
                // window.location.href=`/${pagename}`

            }
            else {

                var msg = resBody?.message

                let data = resBody?.data || {}
                if (data.hasOwnProperty('loginattemptcount')) {
                    setAttemptCount(data.loginattemptcount)
                }
                else {
                    setAttemptCount(null)
                }

                if (resBody?.status === 401 && msg === 'Unauthorized')
                    msg = Config.getErrmsg()['invalidusername']

                if (msg) {
                    if (googlecode || msToken) {
                         //  authcallback take 2 second to return log in screen | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:31 PM
                        setTimeout(() => IISMethods.localnotify(msg, 2), 2000)
                    }
                    IISMethods.localnotify(msg, 2)
                }
                setState({ ...state, addButtonDisable: false })

                // if (msToken) {
                //     IISMethods.logout()
                //     instance.logoutRedirect({
                //         postLogoutRedirectUri: `${Config.getServermode() == 'prod' ? "/login" : `/login?q=${IISMethods.getSubdomainName()}`}`,
                //     })
                //     instance.clearCache()

                // }
                if (msToken) {
                    instance.clearCache()
                }

            }
        }
        else {
            setState({ ...state, addButtonDisable: false })
        }
    }

    const handleSignUp = (type, key, value) => {
        if (type === "checkbox") {
            state.signUpData[key] = (value ? 1 : 0)
        }
        else if (type === 'text') {
            state.signUpData[key] = value
            // JsCall.handleHasVal('form-'+key, value)
        }
        else {
            if (!value || /^\d+$/.test(value)) {
                state.signUpData[key] = value
                // JsCall.handleHasVal('form-'+key, value)
            }
            else if (typeof (value) === "object") {
                state.signUpData.codecontact = value.dialCode
                state.signUpData.countryid = value.iso2
                state.signUpData.countryname = value.name.split(" ")[0]
            }
        }
        setState({ ...state, signUpData: state?.signUpData })
    }

    //PRIYANSHI --> SOCKET
    const handleForgetPassword = (e) => {
        let states = state.forgetData
        if (e.target.name !== "rememberme") {
            states[e.target.name] = e.target.value.trim()
        }
        else {
            states[e.target.name] = e.target.checked
        }
        setState({ ...state, forgetData: { ...states } })
        JsCall.validateForm(state.forgetData, state.forgetPasswordValidations, e.target.name)
    }

    const forgetPassword = async (e, subdomainname) => {
        e.preventDefault()
        const urlparams = Config.getServermode() == 'prod' ? window.location : new URLSearchParams(window.location.search)
        if (!JsCall.validateForm(state.forgetData, state?.forgetPasswordValidations)) {
            const url = Config.weburl + 'forgotpasswordrequest'

            let reqData = state.forgetData
            let headers = {
                token: LoginInfo.getToken(),
                issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
                unqkey: LoginInfo.getUnqkey(),
                uid: LoginInfo.getUid(),
                platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
                useraction: 'forgetpassword',
                pagename: IISMethods.getpagename(),
                subdomainname: subdomainname || Config.getServermode() == 'prod' ? urlparams.hostname?.split('.')[0] : urlparams.get('q'),
                version: Config.version,
                moduletype: 'web'
            }

            //PRIYANSHI --> SOCKET
            let { resBody } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)


            if (resBody.status === 200) {
                setState({ ...state, forgetData: { ...state.forgetData, forgetpassword: !state.forgetData.forgetpassword }, otpData: { ...state.otpData, verifyotp: !state.otpData.verifyotp }, addButtonDisable: false })
                setResendOTPTimer({
                    starttime:resBody?.starttime,
                    endtime:resBody?.endtime,
                })
                IISMethods.localnotify(resBody.message, 1)
            }
            else {
                IISMethods.localnotify(resBody.message, 2)
                setState({ ...state, addButtonDisable: false })
                         setResendOTPTimer({
                    starttime:null,
                    endtime:null,
                })
            }
        }
        else {
            IISMethods.localnotify(Config.errmsg.invalidemail, 2)
            setState({ ...state, addButtonDisable: false })
                         setResendOTPTimer({
                    starttime:null,
                    endtime:null,
                })
        }
    }
     // smit surani ~ 09-04-2025 add login with otp
    const loginWithOTP = async (e, subdomainname) => {
        e.preventDefault()
        const urlparams = Config.getServermode() == 'prod' ? window.location : new URLSearchParams(window.location.search)
        if (!JsCall.validateForm(state.loginWithOTPData, state?.loginwithOTPValidations)) {
            const url = Config.weburl + 'makeotpforloginrequest'

            let reqData = state.loginWithOTPData
            reqData={
                ...reqData,
                email:reqData?.username
            }
            delete reqData?.username
            let headers = {
                token: LoginInfo.getToken(),
                issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
                unqkey: LoginInfo.getUnqkey(),
                uid: LoginInfo.getUid(),
                platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
                useraction: 'loginwithotp',
                pagename: IISMethods.getpagename(),
                subdomainname: subdomainname || Config.getServermode() == 'prod' ? urlparams.hostname?.split('.')[0] : urlparams.get('q'),
                version: Config.version,
                moduletype: 'web'
            }

            //PRIYANSHI --> SOCKET
            let { resBody } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)


            if (resBody.status === 200) {
                setState({ ...state, loginWithOTPData: { ...state.loginWithOTPData, loginwithOTP: true , otpVerification:true }, addButtonDisable: false })
                setSignInWithOTPButtonDisable(false)
                setResendOTPTimer({
                    starttime:resBody?.starttime,
                    endtime:resBody?.endtime,
                })
                IISMethods.localnotify(resBody.message, 1)
            }
            else {
                setSignInWithOTPButtonDisable(false)
                IISMethods.localnotify(resBody.message, 2)
                setState({ ...state, addButtonDisable: false })
                         setResendOTPTimer({
                    starttime:null,
                    endtime:null,
                })
            }
        }
        else {
            setSignInWithOTPButtonDisable(false)
            IISMethods.localnotify(Config.errmsg.invalidemail, 2)
            setState({ ...state, addButtonDisable: false })
                         setResendOTPTimer({
                    starttime:null,
                    endtime:null,
                })
        }
    }
    
     //  smit surani  ~ 2025-07-01 ~ 10:54 AM
    const resendOTP = async (e,isFromLoginWithOTP) => {
        e.preventDefault()
        const urlparams = Config.getServermode() == 'prod' ? window.location : new URLSearchParams(window.location.search)
        let validateForm;
        let pagename='';
        let useraction=''
        let reqData={}
        if(isFromLoginWithOTP){
            validateForm = JsCall.validateForm(state.loginWithOTPData, state?.loginwithOTPValidations)
            pagename='makeotpforloginrequest'
            useraction='makeotpforloginrequest'
        }else{
            
            validateForm = JsCall.validateForm(state.forgetData, state?.forgetPasswordValidations)
            pagename='forgotpasswordrequest'
            useraction='forgetpassword'
        }
        if (!validateForm) {

            const url = Config.weburl + pagename
            if (isFromLoginWithOTP) {
                reqData = {
                    ...state.loginWithOTPData,
                    email:state.loginWithOTPData?.username,
                    resendotp: 1
                };
                delete reqData?.username
       
            } else {
                reqData = {
                    ...state.forgetData,
                    forgetpassword: true,
                    resendotp: 1
                };
            }

            let headers = {
                token: LoginInfo.getToken(),
                issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
                unqkey: LoginInfo.getUnqkey(),
                uid: LoginInfo.getUid(),
                platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
                useraction: useraction,
                pagename: IISMethods.getpagename(),
                subdomainname:  Config.getServermode() == 'prod' ? urlparams.hostname?.split('.')[0] : urlparams.get('q'),
                version: Config.version,
                moduletype: 'web'
            }

            let { resBody } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)

            if (resBody.status === 200) {
                setState({ ...state, resendOTPButtonDisable: false })
                IISMethods.localnotify(resBody.message, 1)
                setResendOTPTimer({
                    starttime: resBody?.starttime,
                    endtime: resBody?.endtime,
                })
            }
            else {
                IISMethods.localnotify(resBody.message, 2)
                setState({ ...state, resendOTPButtonDisable: false })
                setResendOTPTimer({
                    starttime: null,
                    endtime: null,
                })
            }
        }
        else {
            IISMethods.localnotify(Config.errmsg.invalidemail, 2)
            setState({ ...state, resendOTPButtonDisable: false })
            setResendOTPTimer({
                starttime: null,
                endtime: null,
            })
        }
    }

    const handleOtp = (e) => {
        let states = state.otpData
        if (e.target.name !== "rememberme" && e.target.name !== "clearallsessions") {
            states[e.target.name] = (e.target.value).trim()
        }
        else {
            states[e.target.name] = e.target.checked
        }
        setState({ ...state, otpData: states })

        JsCall.validateForm(state.otpData, state.resetPasswordValidations, e.target.name)

    }

    const changePassword = async (e, subdomainname) => {
        e.preventDefault()
        const urlparams = Config.getServermode() == 'prod' ? window.location : new URLSearchParams(window.location.search)

        var formData = {
            otp: state.otpData.otp,
            newpassword: state.otpData.newpassword,
            confirmnewpassword: state.otpData.confirmnewpassword,
            clearallsessions: state.otpData.clearallsessions,
        }

        if (!JsCall.validateForm(formData, state?.resetPasswordValidations)) {
            if (state.otpData?.confirmnewpassword !== state.otpData?.newpassword) {
                IISMethods.localnotify(Config.errmsg.passwordvalidation, 2)
                setState({ ...state, addButtonDisable: false })
            } else {

                var formData = { ...formData, 'email': state.forgetData.email }
                const url = Config.weburl + 'resetpassword'

                let reqData = formData
                let headers = {
                    token: LoginInfo.getToken(),
                    issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
                    unqkey: LoginInfo.getUnqkey(),
                    uid: LoginInfo.getUid(),
                    platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
                    useraction: 'resetpassword',
                    pagename: IISMethods.getpagename(),
                    subdomainname: subdomainname || Config.getServermode() == 'prod' ? urlparams.hostname?.split('.')[0] : urlparams.get('q'),
                    version: Config.version,
                    moduletype: 'web'
                }

                //PRIYANSHI --> SOCKET
                let { resBody } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)

                if (resBody.status === 200) {
                    setState({ ...state, forgetData: { ...state.forgetData, forgetpassword: false, email: '' }, otpData: { ...state.otpData, verifyotp: false, newpassword: '', confirmnewpassword: '', otp: '' }, addButtonDisable: false })
                    IISMethods.localnotify(resBody.message, 1)
                }
                else {
                    IISMethods.localnotify(resBody.message, 2)
                    setState({ ...state, addButtonDisable: false })
                }
            }
        }
        else {
            setState({ ...state, addButtonDisable: false })
        }

    }

    const handleGrid = useCallback(
        (id, type, key, value, editeDataIndex) => {

            if (type === 'switch' || type === 'checkbox') {
                var object = IISMethods.getCopy(IISMethods.getobjectfromarray(getCurrentState().data, '_id', id))
                object[key] = (value ? 1 : 0)
                // updateData(object, editeDataIndex)
            }
            else if (type === 'dropdown') {
                var object = IISMethods.getCopy(IISMethods.getobjectfromarray(getCurrentState().data, '_id', id))
                const fieldobj = IISMethods.getobjectfromarray(getCurrentState().fieldOrder, 'field', key)
                const masterdataobject = IISMethods.getobjectfromarray(getCurrentState().masterData[fieldobj.masterdata], 'value', value)
                object[key] = masterdataobject.label
                object[key + 'id'] = masterdataobject.value
                // updateData(object, editeDataIndex)
            }
            else if (type === 'modal') {
                if (value) {
                    getCurrentState().modal[key] = id
                }
                else {
                    delete getCurrentState().modal[key]
                }
                props.setProps({ modal: IISMethods.getCopy(getCurrentState().modal) })
            }
            else {

            }

        }
        ,
        [state]
    )


    //********** 2FA Starts
    const handle2FAValidation = (key, value) => {
        let otperr = IISMethods.getCopy(otpError)
        let keyVal = Object.keys(otpState)?.filter((key) => otpState[key] === '')
        if (key) { if (value) delete otperr[key] }
        else for (let key of keyVal) { otperr[key] = 1 }
        setOtpError(IISMethods.getCopy(otperr))
        return keyVal?.length === 0
    }

    const handleOTPChange = (type, key, value, index) => {
        let otpdata = IISMethods.getCopy(otpState)
        if (type === 'number-input') {
            otpdata[key] = value ? value.at(-1) : ''
            handle2FAValidation(key, value)
            if (value && index !== (inputRef?.length - 1)) inputRef[index + 1]?.current?.focus()

        }
        setOtpState(IISMethods.getCopy(otpdata))
    }

    //  For Verify Entered OTP & Enable 2FA
    // const handleSignInWith2FA = async (otp) => {
    //     // await addLoaders('verifyotp', 1)

    //     let url = Config.weburl + '2FA/login'

    //     let resp = getCurrentState().loginresp?.data
    //     let headers = getCurrentState().loginresp?.headers

    //     let reqData = {}
    //     reqData['requestid'] = resp.data[0].requestid
    //     reqData['twoFACode'] = otp || ''

    //     let header = {
    //         subdomainname: getCurrentState().loginData?.subdomainname || '',
    //         uid: resp.data[0]._id,
    //         token: headers?.token,
    //         unqkey: headers?.unqkey,
    //         userroleid: resp.data[0]?.userrole[0]?.userroleid,
    //         propertyname: '',
    //         propertyid: '',
    //         branchid: Config.dummyid,
    //         companyid: resp.data[0].companyid,
    //         username: resp.data[0].firstname + ' ' + resp.data[0].lastname,
    //         useraction: '2FAlogin'
    //     }


    //     if (resBody.status === 200) {
    //         getCurrentState().loginresp.headers.token = resHeaders.token
    //         getCurrentState().loginresp.headers.unqkey = resHeaders.unqkey
    //         await props.setProps({ loginresp: IISMethods.getCopy(getCurrentState().loginresp) })
    //         // await signIn()
    //         // await addLoaders('verifyotp', 0)
    //     }
    //     else {
    //         // await addLoaders('verifyotp', 0)
    //         IISMethods.localnotify(resBody.message)
    //     }
    // }


    // const handleSubmit = async () => {
    //     let isValid = handle2FAValidation()
    //     if (isValid) {
    //         setOtpError({})
    //         let otp = Object.values(otpState).join('')
    //         await handleSignInWith2FA(otp)
    //     }
    // }

    const handleVerifyOTP = async (otp) => {

        let url = Config.weburl + '2FA/recoverycode/verify'
        let useraction = 'addright'

        let reqBody = {
            email: isEmail(state.loginData.username) ? state.loginData.username.trim().toLowerCase() : state.loginData.username.trim(),
            password: state.loginData.loginpassword,
            recoverycode: otp,
            requestid: res2FAData.requestid
        }


        let reqheader = {
            token: reqRecoveryData.token,
            issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
            unqkey: reqRecoveryData.unqkey,
            uid: reqRecoveryData.uid,
            platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
            useraction: useraction,
            pagename: IISMethods.getpagename(),
            subdomainname: reqRecoveryData?.subdomainname,
            username: reqRecoveryData.firstname + ' ' + reqRecoveryData.lastname,
            companyid: reqRecoveryData.companyid,
            branchid: reqRecoveryData.branchid,
            //Priyanshi Userrole  --> need change
            userroleid: reqRecoveryData.userroleid,
            version: Config.version,
            moduletype: 'web'
            // for public ip
            // publicip : loginInfo.clientpublicip
        }

        //PRIYANSHI --> SOCKET
        let { resBody , resHeaders } = await IISMethods.socketListData(url, reqBody, undefined, false, {}, undefined, false, null, reqheader)

        if (resBody.status === 200) {
            IISMethods.localnotify(resBody.message, 1)
            await handleGrid(false, 'modal', 'twofactorauth', 0)
            await handleGrid(false, 'modal', 'recoveycode', 0)
            setIs2FA(false)
            setRes2FAData({})
            setReqRecoveryData({})
            setRecoveryButtonDisable(false)
        }
        else {
            setRecoveryButtonDisable(false)
            IISMethods.localnotify(resBody.message, resBody.status, 2)
        }

        return { resBody, resHeaders }
    }
    //********** 2FA ends

try {
    return (
        <>  
            <Index
            handleSignIn={handleSignIn}
            signIn={signIn}
            handleSignUp={handleSignUp}
            tnc={state?.signUpData?.termsandcondition}
            phoneno={state?.signUpData?.contact}
            loginData={state?.loginData}
            setState={setState}
            state={state}
            handleForgetPassword={handleForgetPassword}
            forgetPassword={forgetPassword}
            handleOtp={handleOtp}
            changePassword={changePassword}

            handleGrid={handleGrid}
            //2FA
            is2FA={is2FA}
            setIs2FA={setIs2FA}
            inputRef={inputRef}
            otpError={otpError}
            otpState={otpState}
            handleOTPChange={handleOTPChange}
            recoveryButtonDisable={recoveryButtonDisable}
            setRecoveryButtonDisable={setRecoveryButtonDisable}
            handleVerifyOTP={handleVerifyOTP}
            from={props.from}

            // login attempt
            attemptCount={attemptCount}
            getAccessToken={getAccessToken}
            tenantLogo={tenantLogo}
            isUsernameErr={isUsernameErr}
            sliderImages={sliderImages}
            resendOTP={resendOTP} //  smit surani  ~ 2025-07-01 ~ 10:54 AM
            resendOTPTimer={resendOTPTimer} //  smit surani  ~ 2025-07-01 ~ 10:54 AM
            setResendOTPTimer={setResendOTPTimer} //  smit surani  ~ 2025-07-01 ~ 10:54 AM
            loginWithOTP={loginWithOTP}  // smit surani ~ 09-04-2025 add login with otp
            logoLoader={logoLoader}
            otpValue={otpValue}  // smit surani ~ 09-04-2025 add login with otp
            setOtpValue={setOtpValue}  // smit surani ~ 09-04-2025 add login with otp
            signInWithOTPButtonDisable={signInWithOTPButtonDisable}  // smit surani ~ 09-04-2025 add login with otp
            setSignInWithOTPButtonDisable={setSignInWithOTPButtonDisable}  // smit surani ~ 09-04-2025 add login with otp
        />
        </>
        
    )
} catch (e) {
    console.log(e);
    return <></>   
}
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    setLocalStorageData: (payload) => dispatch(setLocalStorageData(payload)),
    setCookiesData: (payload) => dispatch(setCookiesData(payload)),
    setProps: (payload) => dispatch(setProps(payload)),
    setMenuData: (payload) => dispatch(setMenuData(payload)),
    setUserRights: (payload) => dispatch(setUserRights(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)
